"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noticeHtml = exports.connectedNoticeHtml = void 0;

const noticeHtml = (elementId, imageSrc, iconImage) => {
  return "\n  <div id=\"".concat(elementId, "-label-container\">\n    <div id=\"").concat(elementId + '-close', "\">\n      <img src=\"").concat(iconImage, "\" height=\"15\" width=\"11\" />\n    </div>\n    <img id=\"").concat(elementId + '-img', "\" src=\"").concat(imageSrc, "\"/>\n    <span id=\"").concat(elementId + '-label-text', "\">MEW&nbsp;wallet</span>\n  </div>\n  \n  <div id=\"").concat(elementId + '-text', "\">\n  \n  </div>\n  ");
};

exports.noticeHtml = noticeHtml;

const connectedNoticeHtml = (elementId, imageSrc, iconImage) => {
  return "\n  <img id=\"".concat(elementId, "-img\" src=\"").concat(imageSrc, "\" />\n  <div id=\"").concat(elementId, "-label-container\">\n    <div id=\"").concat(elementId, "-close\">\n      <img src=\"").concat(iconImage, "\" height=\"15\" width=\"11\"/>\n    </div>\n    \n    <div class=\"").concat(elementId, "-vertical-flex\">\n      <span class=\"").concat(elementId, "-label-text\">Connected to</span>\n      <span class=\"").concat(elementId, "-big\">MEW&nbsp;wallet</span>\n      <span class=\"").concat(elementId, "-label-text\">Powered by MyEtherWallet</span>\n    </div>\n  </div>\n  ");
};

exports.connectedNoticeHtml = connectedNoticeHtml;